require('../modules/web.timers');
var path = require('../internals/path');

module.exports = path.setTimeout;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/set-timeout.js
// module id = 1134
// module chunks = 0